import { render, staticRenderFns } from "./approvalHandover.vue?vue&type=template&id=078c41dc&scoped=true&"
import script from "./approvalHandover.vue?vue&type=script&lang=js&"
export * from "./approvalHandover.vue?vue&type=script&lang=js&"
import style0 from "./approvalHandover.vue?vue&type=style&index=0&id=078c41dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "078c41dc",
  null
  
)

export default component.exports